/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_5_SentryInputs */

const en_privacy_section_5_sentry = /** @type {(inputs: Privacy_Section_5_SentryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sentry`)
};

const lv_privacy_section_5_sentry = /** @type {(inputs: Privacy_Section_5_SentryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sentry`)
};

/**
* | output |
* | --- |
* | "Sentry" |
*
* @param {Privacy_Section_5_SentryInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_5_sentry = /** @type {((inputs?: Privacy_Section_5_SentryInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_5_SentryInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_5_sentry(inputs)
	return en_privacy_section_5_sentry(inputs)
});